import ModalComponent from '@components/common/Modal';
import { Input } from 'antd';
import { IOrderManager } from 'models/OrderManager';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IDeleteOrder {
  isOpen: boolean;
  rowSelect?: IOrderManager;
  callBackClose: () => any;
  callBackRefresh: () => any;
  callBackDelete: (data) => any;
}

export default function CancelOrderModal(props: IDeleteOrder) {
  const { t } = useTranslation();
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [reason, setReason] = useState<string>('');
  const handleOk = () => {
    try {
      if (props) {
        setConfirmLoading(true);
        // xoá ở local
        console.log(props.rowSelect);
        props.callBackDelete(reason);
        // cần hiện popup cập nhật xong
        // có thể đặt trong kq của api trả về
        setTimeout(() => {
          setConfirmLoading(false);
          props.callBackClose();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    props.callBackClose();
  };
  return (
    <>
      <ModalComponent
        modalTitle={t('OrganizedSales.OrderManager.ModifyOrder.CancelOrderModal.Title')}
        modalType="cancel"
        modalSize="auto"
        visible={props.isOpen}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        justifyMiddle={true}
      >
        {/* <div className="flex space-x-8 align-middle text-sm">{t('OrganizedSales.Staff.Delete.Message')}</div> */}
        <label className="text-base p-2">{t('OrganizedSales.OrderManager.ModifyOrder.CancelOrderModal.Reason')}</label>
        <Input value={reason} placeholder={t('Input.placeholder')} onChange={e => setReason(e.target.value)} />
      </ModalComponent>
    </>
  );
}
